// extracted by mini-css-extract-plugin
export default {"header":"header_header__Xrmhv","header_full":"header_header_full__RHMDx"};